module.exports = __webpack_public_path__ + "img/speciment03.d6e1d18d.png";